/*
 * slider/index.js
 *
 * This file contains the default setup for slick slider and provides a method to initlise new carousels
 * with these GS FED Boilerplate defaults. This component is designed to be included with other components, see usage
 * below:
 *
 * import slider from '../slider';
 *
 * let customOpts = { yourCustomOpts }
 * slider('.my-custom-slider-class', customOpts);
 *
 */
import $ from 'jquery';
import 'slick-carousel';

// Create slick carousel on the passed in element and option values
function createSlider(element, customOpts) {
    const $sliderContainer = $(element).children('.slider-container');
    const $slider = $(element).find('.inner');

    // GS FED Boilerplate default options for the slider, best not change these!
    const slickDefaults = {
        mobileFirst: true,
        appendArrows: $sliderContainer.find('.slider-controls'),
        appendDots: $sliderContainer.find('.slider-controls'),
        dots: true,
        speed: 300,
        autoplaySpeed: 20000,
        prevArrow: '<button type="button" role="button" class="slick-prev slick-arrow"><svg class="svg-icon"><use xlink:href="#arrow-left" /></svg><span>Previous</span></button>',
        nextArrow: '<button type="button" role="button" class="slick-next slick-arrow"><span>Next</span> <svg class="svg-icon"><use xlink:href="#arrow-right" /></svg></button>',
        slide: '.slide-item'
    };

    // Extend the defaults for your specific purpose
    const slickOpts = Object.assign(customOpts, slickDefaults);
    $slider.slick(slickOpts);
    $slider.find('.slide-item').removeAttr('aria-describedby');

    $slider.on('breakpoint', () => {
        alignStackedSlider();
    });
}

function slider(elem, customOpts = {}) {
    // Find the custom element
    // NOTE: Always prefixed with c-slider
    const $component = $(`.c-slider.${elem}`);

    // Init all the sliders on the page one at a time
    $component.each(function () {
        const sliderElement = this;
        createSlider(sliderElement, customOpts);
    });
}

// This function will give all the stacked slider items the same height
export function alignStackedSlider() {
    const $sliders = $('.c-slider');

    // Check and align each slider
    $sliders.each(function () {
        alignStack(this);
    });
}

function alignStack($slider) {
    const $stacked = $($slider).find('.slide-item.stacked');
    if (!$stacked.length) { return; }

    // Vars for the element height
    const elementHeight = [];

    // Find the tallest
    $stacked.each(function () {
        // Only bother with height alignment if we have multiple items in a stack
        $(this).children().each((index, item) => {
            $(item).height('');
            const itemHeight = $(item).height();
            if (!elementHeight[index] || elementHeight[index] < itemHeight) {
                elementHeight[index] = itemHeight;
            }
        });
    });

    // Set the stacked item height
    $stacked.each(function () {
        // Only bother with height alignment if we have multiple items in a stack
        $(this).children().each((index, item) => {
            $(item).height(elementHeight[index]);
        });
    });
}

export default slider;



// WEBPACK FOOTER //
// ./src/components/slider/c-slider.js